function getCookie(cookieName) {
	let cookies = document.cookie;
	let cookieArray = cookies.split("; ");

	for (let i = 0; i < cookieArray.length; i++) {
		let cookie = cookieArray[i];
		let [name, value] = cookie.split("=");

		if (name === cookieName) {
			return decodeURIComponent(value);
		}
	}

	return null;
}

function deleteCookie(cookieName) {
	document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

const orderCookieName = "orderId";
const orderId = getCookie(orderCookieName);

if (orderId) {
	deleteCookie(orderCookieName);
	const thankYouPageUrl = "http://test.onlyinboards.com/shop/thank-you";
	window.location.href = thankYouPageUrl + "?orderId=" + orderId;
}